export default "__VITE_ASSET__8oc9TxdG__"